define('app-emailOnly/main',[], function () {
    return {

        container: "#email-only-banner",

        submitUrl: window.location.protocol + '//' + window.location.host + '/emailonly/banner',

        submitted: false,

        IsInputValid: function (input) {
            var $input = $(input),
                inputValidation = new RegExp($input.data('val-regex-pattern')),
                inputValue = $input.val();

            return inputValidation.test(inputValue);
        },

        updateValidationMessage: function (input, isValid) {
            var $input = $(input),
                validationMessage = $input.parent().find('.validation-message');

            if (isValid) {
                validationMessage.addClass('d-none');
                $input.removeClass('invalid');
            } else {
                validationMessage.removeClass('d-none');
                $input.addClass('invalid');
            }
        },

        //Returns an array of invalid inputs
        validateControls: function (form) {
            var $this = this,
                inputs = $(form).find('input[type=text], input[type=email]'),
                invalidInputs = [];
                
            $.each(inputs, function (index, input) {
                var $input = $(input),
                    isValid = $this.IsInputValid($input);
                    
                if (!isValid) {   
                    $this.updateValidationMessage($input, isValid);
                    invalidInputs.push(input);
                }
            })

            return invalidInputs;
        },

        watchChange: function (changedInput) {
            var $this = this,
                $changedInput = $(changedInput);

            if (!$this.submitted) {
                return;
            }

            var isValid = $this.IsInputValid($changedInput);
            $this.updateValidationMessage($changedInput, isValid);
        },

        //Without working unobtrusive validation, using this hack
        populateValidationMessage: function (input) {
            var $input = $(input);
            validationMessage = $input.data('val-regex');
            $input.parent().find('.validation-message').text(validationMessage);
        },

        run: function () {
            var $this = this,
                container = $(this.container);

            if (container.length <= 0) {
                return;
            };

            var form = container.find('form'),
                submit = form.find('button'),
                textInputs = form.find('input[type=text], input[type=email]');

            $.each(textInputs, function (index, input) {
                $this.populateValidationMessage(input);

                $(input).on("input", function () {
                    $this.watchChange(input);
                });
            })

            submit.on('click', function (event) {
                event.preventDefault();
                $this.submitted = true;

                var invalidInputs = $this.validateControls(form);

                if (invalidInputs.length === 0) {

                    var button = form.find('button');
                        button.attr('disabled', '').empty().append("<img src='/Content/Background/bx_loader.gif' alt='submitting' />"),
                        data = form.serialize(),
                        request = $.ajax({
                            url: $this.submitUrl,
                            cache: false,
                            type: "POST",
                            contentType: "application/x-www-form-urlencoded",
                            data: data
                        });

                    request.done(function (result) {
                        container.find('.banner-body').empty().append(result);
                    });

                    request.fail(function () {
                        var content = container.find('.banner-content');
                        content.find('.banner-body').remove();
                        content.find('.banner-image').remove();
                        content.find('.banner-result').removeClass('d-none');
                    });
                }
            });
        }
    };
});
